import $ from 'jquery';
import { BaseMask } from './base.mask';

const DEFINITIONS = {
    '#': { validator: '[0-9]', cardinality: 1, casing: 'lower' },
    '*': { validator: '[a-zA-Z0-9]' },
    '@': { validator: '[a-zA-Z]' },
    '=': { validator: '[a-zA-Z0-9]' },
};

const AVAILABLE_COUNTRIES = [
    /** Austria */ 'AT',
    /** Belgium */ 'BE',
    /** Czech Republic */ 'CZ',
    /** Denmark */ 'DK',
    /** Finland */ 'FI',
    /** France */ 'FR',
    /** Germany */ 'DE',
    /** Ireland */ 'IE',
    /** Italy */ 'IT',
    /** Luxembourg */ 'LU',
    /** Netherlands */ 'NL',
    /** Norway */ 'NO',
    /** Poland */ 'PL',
    /** Portugal */ 'PT',
    /** Spain */ 'ES',
    /** Sweden */ 'SE',
    /** United Kingdom: Great Britain */ 'GB',
    /** United Kingdom */ 'UK',
];

export class VatMask extends BaseMask {
    static getDefinitions() {
        return DEFINITIONS;
    }
    getClassConstructor() {
        return VatMask;
    }
    getConfig() {
        return 'validationVatCfg';
    }
    getInvalidMsg() {
        return 'MASK_VAT_INVALID';
    }

    getInvalidMsgAttr() {
        return 'data-msg-maskvatnumber';
    }

    isCountryAvailableForMask(countryCode) {
        return AVAILABLE_COUNTRIES.indexOf(countryCode.toUpperCase()) !== -1;
    }

    getPropertyName(property) {
        if (this.propertyPostfix === undefined) {
            const { configPostfix } = this.domEl.dataset;
            this.propertyPostfix = configPostfix ? `_${configPostfix}` : '';
        }
        return property + this.propertyPostfix;
    }

    static maskMethod(value, element) {
        const $element = $(element);
        const im = $element.data('im');
        const $hintMessageBlock = $('span.vat-format');

        const keydownValidation = (im && im.enterKeydownValidation) || false;

        if ($element.is(':focus') && !keydownValidation) {
            // $element.removeClass('error');
            // $element.siblings('.error-tooltip').addClass('hidden');
            $element.on('blur', () => {
                $element.siblings('.error-tooltip').removeClass('hidden');
            });
            $hintMessageBlock.removeClass('hidden');

            return true;
        }

        if (im && keydownValidation) {
            im.enterKeydownValidation = false;
        }

        const emptyMask = im.getemptymask();

        if ($element.val().length === 0 || $element.val() === emptyMask) {
            return true;
        }
        // check if mask valid and complete

        if (!im.isComplete() || !im.isValid()) {
            $element.addClass('error');
            $element.siblings('.error-tooltip').removeClass('hidden');
            $hintMessageBlock.addClass('hidden');

            return false;
        }

        // es specific
        if (im.isComplete() && im.maskset.mask.indexOf('=') > -1) {
            var firstSym = im.maskset.buffer[2];
            var lastSym = im.maskset.buffer[im.maskset.buffer.length - 1];

            return new RegExp('[a-zA-Z]').test(firstSym) || new RegExp('[a-zA-Z]').test(lastSym);
        }

        $element.removeClass('error');
        $element.siblings('.error-tooltip').addClass('hidden');
        $hintMessageBlock.removeClass('hidden');
        return true;
    }

    static adjustView() {
        return null;
    }
}

VatMask.MASK_NAME = 'vat';
